import React from 'react';
import type { AppManifest } from '@api/apps';
import { LogoImage } from './AppLogo.styled';

const AppLogo: React.FC<{ readonly manifest: AppManifest; readonly dataTestId: string }> = ({ manifest, dataTestId }) => {
  const logo = manifest.presentation?.logo;
  return logo ? <LogoImage src={logo} alt="" data-testid={dataTestId} /> : null;
};

export default AppLogo;
